// extracted by mini-css-extract-plugin
module.exports = {"form-upload-style":"styles_form-upload-style__1vDtu","textarea-upload-style":"styles_textarea-upload-style__AzxqA"};